







































import Vue from 'vue'
import { isInteger } from 'lodash'
import mixins from 'vue-typed-mixins'
import TreatmentMixin from '@/views/treatment/TreatmentMixin'

export default mixins(TreatmentMixin).extend({
  computed: {
    letterNumber(): number {
      return this.breadcrumb || parseInt(this.letter.substring(1), 10) - 1
    },
  },
  props: {
    days: {
      type: Number,
      validator: isInteger,
      default: 2,
    },
    minDays: {
      type: Number,
      default: 2,
    },
    maxDays: {
      type: Number,
      default: 20,
    },
    letter: {
      type: String,
      required: true,
    },
    breadcrumb: {
      type: Number,
    },
  },
  data() {
    const inNDays = new Date()
    inNDays.setDate(inNDays.getDate() + this.days)
    return {
      nextSessionStartInDays: inNDays,
    }
  },
})
